module.exports = "img/flags/RU.c95849b.png";